import {
  Box,
  Typography,
  Dialog,
  DialogContent,
  useMediaQuery,
  useTheme,
  TextField,
  CircularProgress,
} from "@mui/material";
import styles from "../InternalTracker.module.css";
import { customTextColor } from "../../../utils/const";
import InternalTable from "./InternalTable";
import SearchTracker from "./SearchTracker";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { IoIosAdd } from "react-icons/io";
import { useDispatch, useSelector } from "react-redux";
import { getSubmissionTracker } from "../../../redux/internal-tracking/InternalSubmissionSlice";
import { getRequirementCandidates } from "../../../redux/post-requirement/postRequirementSlice";
import { allLocation } from "../../../redux/common/locationSlice";
import { getProfile } from "../../../redux/profile/profileSlice";
import AddSubmisionDrawer from "./AddSubmisionDrawer";

const InternalTracker = () => {
  const [open, setOpen] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [openAddTrack, setOpenAddTrack] = useState(false);
  const [internalTrack, setInternalTrack] = useState([]);
  const [internalTrackList, setInternalTrackList] = useState([]);
  const [jobTitles, setJobTitles] = useState([]);
  const [userIDSearch, setUserIDSearch] = useState("");
  const [show, setShow] = useState(false);
  const [submisionRow, setSubmisionRow] = useState({});
  const handleCloseShow = () => setShow(false);
  const handleShow = () => setShow(true);

  const [searchData, setSearchData] = useState({
    requirement_type: [],
    locations: [],
    start_date: "",
    end_date: "",
    job_title: [],
  });
  const trackDetails = useSelector((state) => state.trackersubmission);
  const theme = useTheme();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const dispatch = useDispatch();

  const locations = useSelector((state) => state.location);
  const profile = useSelector((state) => state.profile.data);
  const internalCandidateStatic = useSelector(
    (state) => state.internalCandidateStatic.data
  );
  const staticData = useSelector((state) => state.static.data);
  const postCandidateData = useSelector(
    (state) => state.postrequirement.candidateData
  );
  const requirementLoading = useSelector(
    (state) => state.postrequirement.status
  );

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpenAddTrack(false);
  };

  const handleClickOpenAddTrack = () => {
    setOpenAddTrack(true);
  };

  const handleCloseAddTrack = () => {
    setOpenAddTrack(false);
  };

  useEffect(() => {
    dispatch(allLocation());
    dispatch(getProfile());
  }, [dispatch]);

  useEffect(() => {
    if (trackDetails) {
      setInternalTrack(trackDetails?.data?.requirements);
      setInternalTrackList(trackDetails?.data?.requirements);
    }
  }, [trackDetails]);

  const handleOnClear = () => {
    setSearchData({
      requirement_type: [],
      locations: [],
      start_date: "",
      end_date: "",
      job_title: [],
    });
    let queryString = `page=${page}&page_size=${rowsPerPage}`;

    dispatch(getSubmissionTracker(queryString));
  };

  useEffect(() => {
    if (internalTrackList) {
      const jobTitle = internalTrackList
        ?.map((requirement) => requirement.job_title)
        .filter(
          (title, index, self) => title && self?.indexOf(title) === index
        );
      setJobTitles(jobTitle);
    }
  }, [internalTrackList]);

  useEffect(() => {
    let queryString = `page=${page}&page_size=${rowsPerPage}`;
    dispatch(getSubmissionTracker(queryString));
  }, [page, rowsPerPage]);

  const handleOnClickSearch = () => {
    if (searchData) {
      const queryParams = Object.keys(searchData).reduce((acc, key) => {
        const value = searchData[key];

        if (Array.isArray(value) && value.length > 0) {
          acc[key] = JSON.stringify(value);
        } else if (
          value !== "" &&
          value !== null &&
          value !== undefined &&
          !Array.isArray(value)
        ) {
          acc[key] = value;
        }
        return acc;
      }, {});


      const queryString = Object.entries(queryParams)
        .map(
          ([key, value]) =>
            `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
        )
        .join("&");

      let quiry = `${queryString}&page=${page}&page_size=${rowsPerPage}`;
      dispatch(getSubmissionTracker(quiry));
    } else {
      let queryString = `page=${page}&page_size=${rowsPerPage}`;
      dispatch(getSubmissionTracker(queryString));
    }
  };

  const handleChangeOnJobID = (e) => {
    let userID = e.target.value;
    setUserIDSearch(userID);
    if (userID.length > 5) {
      dispatch(getRequirementCandidates(userID));
    }
  };

  const getPreferLocationNames = (preferLocation) => {
    return preferLocation
      ?.map(
        (id) =>
          locations?.data?.locations?.find((location) => location.id === id)
            ?.name
      ) // Map IDs to names
      ?.filter(Boolean) // Remove any undefined values if IDs don't match
      ?.join(", "); // Join names with a comma and space
  };

  const handleonClickTrackAdd = () => {
    if (profile?.profile?.role === "BENCH_SALES_RECRUITER") {
      handleClickOpen();
    } else {
      handleClickOpenAddTrack();
    }
  };

  return (
    <Box className={styles.internal_tracker_structure}>
      <Box className={styles.track_submissions_heading}>
        <Box>
          {""}
          <Typography sx={{ color: customTextColor }}>
            {/* Submission Tracker */}
          </Typography>
        </Box>
        {profile?.profile?.role !== "BENCH_SALES_RECRUITER" && (
          <button onClick={handleonClickTrackAdd}>
            Track Submissions <IoIosAdd style={{ fontSize: "25px" }} />
          </button>
        )}
      </Box>

      <Box
        sx={{
          // padding: "10px 0 ",
          backgroundColor: "#fff",
          marginBottom: "14px",
        }}
      >
        <Box>
          <SearchTracker
            handleOnClickSearch={handleOnClickSearch}
            handleOnClear={handleOnClear}
            jobTitles={jobTitles}
            setSearchData={setSearchData}
            searchData={searchData}
          />
        </Box>
      </Box>
      <InternalTable
        internalTrack={internalTrack}
        setPage={setPage}
        page={page}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
      />

      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
        maxWidth="sm"
        fullWidth={true}
      >
        <DialogContent sx={{ backgroundColor: "#f2f2f2" }}>
          <Box className={styles.feedback_listing_details}>
            <Typography>
              <b>100% free Submission Requirement Tracking for now</b>
            </Typography>
          </Box>

          <Box className={styles.tracker_details}>
            <span>
              <Typography>
                <b>Simple track your candidate submissions and keep updated.</b>
              </Typography>
              <Typography>Get status before next submission</Typography>
            </span>

            <span>
              <button
                onClick={() => {
                  // navigate("/internal-tracker-submissions");
                  handleShow();
                  localStorage.setItem(
                    "internalSubmissionDetailsWhichView",
                    JSON.stringify({ type: "add" })
                  );
                  localStorage.setItem(
                    "internalSubmissionDetails",
                    JSON.stringify({ type: "add" })
                  );
                }}
              >
                Add Now
              </button>
            </span>
          </Box>
        </DialogContent>
      </Dialog>

      <Dialog
        fullScreen={fullScreen}
        open={openAddTrack}
        onClose={handleCloseAddTrack}
        aria-labelledby="responsive-dialog-title"
        maxWidth="sm"
        fullWidth={true}
      >
        <DialogContent sx={{ backgroundColor: "#f2f2f2" }}>
          <Box className={styles.feedback_listing_details}>
            <Typography>
              <b>100% free Submission Requirement Tracking for now</b>
            </Typography>
          </Box>

          <Box className={styles.tracker_details}>
            <span>
              <Typography>
                <b>Simple track your candidate submissions and keep updated.</b>
              </Typography>
              <Typography>Get status before next submission</Typography>
            </span>
          </Box>

          <Box
            className={styles.tracker_details}
            sx={{ marginTop: "10px", justifyContent: "flex-start" }}
          >
            <TextField
              id="outlined-basic"
              type="text"
              variant="outlined"
              size="small"
              placeolder="Job ID/Job Title"
              onChange={handleChangeOnJobID}
              sx={{
                backgroundColor: "#fff",
                width: "35%",
                marginRight: "20px",
              }}
              name="job_id"
            />

            <button
              onClick={() => {
                handleShow();
                handleCloseAddTrack();
                handleClose();
                setSubmisionRow({});
                localStorage.setItem(
                  "internalSubmissionDetailsWhichView",
                  JSON.stringify({ type: "add" })
                );
                localStorage.setItem(
                  "internalSubmissionDetails",
                  JSON.stringify({ type: "add" })
                );
              }}
              sx={{ width: "50%" }}
            >
              Track Submission Manually
            </button>
          </Box>

          {requirementLoading === "loading" ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: 50,
              }}
            >
              <CircularProgress size={30} color="info" />
            </Box>
          ) : (
            userIDSearch?.length > 5 &&
            postCandidateData?.job !== undefined && (
              <Box
                className={styles.tracker_details}
                sx={{
                  margin: "10px",
                  border: "1px solid #ccc",
                  borderRadius: "3px",
                  padding: "10px",
                }}
              >
                <span>
                  <Typography>
                    <b>{postCandidateData?.job?.job_id}</b>
                  </Typography>
                  <Typography>
                    <b>
                      {postCandidateData?.job?.job_title} -{" "}
                      {getPreferLocationNames(postCandidateData?.job?.location)}
                    </b>
                  </Typography>
                </span>

                <button
                  onClick={() => {
                    setSubmisionRow(postCandidateData?.job);
                    handleShow();
                    handleCloseAddTrack();
                    handleClose();

                    localStorage.setItem(
                      "internalSubmissionDetailsWhichView",
                      JSON.stringify({ type: "add" })
                    );

                    localStorage.setItem(
                      "internalSubmissionDetails",
                      JSON.stringify({
                        row: postCandidateData?.job,
                        type: "add",
                      })
                    );
                  }}
                  sx={{ width: "50%" }}
                >
                  Track Now
                </button>
              </Box>
            )
          )}
        </DialogContent>
      </Dialog>

      <AddSubmisionDrawer
        handleShow={handleShow}
        handleClose={handleCloseShow}
        show={show}
        row={submisionRow}
        setIsEdit={setIsEdit}
        isEdit={isEdit}
      />
    </Box>
  );
};
export default InternalTracker;
